module.exports = __webpack_public_path__ + "img/buddy_nose-06.a5b59219.svg";